const topics = [
  {
    title: '本周热映精选',
    desc: '精选本周最受关注的热门电影，涵盖动作巨制、温情剧情与高分佳片，让您不错过每一部值得看的好电影。',
    img: 'https://readdy.ai/api/search-image?query=A%20cinematic%20movie%20marquee%20scene%20with%20warm%20golden%20spotlight%20illuminating%20a%20dark%20theater%20interior%2C%20elegant%20red%20curtain%20drapes%2C%20atmospheric%20ambient%20glow%2C%20luxurious%20cinema%20aesthetic%2C%20no%20text%20no%20faces%20no%20logos%2C%20soft%20focus%20background&width=800&height=500&seq=carousel-01-hot&orientation=landscape',
    alt: '本周热映精选',
  },
  {
    title: '高分悬疑专场',
    desc: '烧脑反转剧情一网打尽，从经典推理到心理惊悚，每一部都让你屏息凝神看到最后一秒。',
    img: 'https://readdy.ai/api/search-image?query=A%20mysterious%20atmospheric%20scene%20with%20deep%20shadows%20and%20a%20single%20warm%20light%20source%2C%20film%20noir%20inspired%20lighting%2C%20abstract%20detective%20elements%2C%20dark%20moody%20background%20with%20subtle%20crimson%20accents%2C%20no%20text%20no%20faces%20no%20logos%2C%20cinematic%20composition&width=800&height=500&seq=carousel-02-suspense&orientation=landscape',
    alt: '高分悬疑专场',
  },
  {
    title: '经典港片回顾',
    desc: '重温黄金年代港产片经典，警匪对决、江湖情义、无厘头喜剧，一代人的光影记忆永久珍藏。',
    img: 'https://readdy.ai/api/search-image?query=Retro%20Hong%20Kong%20cityscape%20at%20night%20with%20neon%20signs%20and%20warm%20golden%20street%20lights%2C%20nostalgic%20cinematic%20atmosphere%2C%20rain%20slicked%20streets%20reflecting%20colorful%20lights%2C%20vintage%20film%20aesthetic%2C%20no%20text%20no%20faces%20no%20logos&width=800&height=500&seq=carousel-03-hkfilm&orientation=landscape',
    alt: '经典港片回顾',
  },
  {
    title: '动画电影盛宴',
    desc: '国内外高分动画长片齐聚，从治愈系到奇幻冒险，全年龄段都能找到属于自己的动画世界。',
    img: 'https://readdy.ai/api/search-image?query=A%20vibrant%20colorful%20abstract%20animation%20studio%20scene%20with%20soft%20pastel%20gradients%20and%20warm%20magical%20lighting%2C%20whimsical%20bokeh%20effects%2C%20creative%20artistic%20atmosphere%2C%20playful%20and%20enchanting%20visual%20style%2C%20no%20text%20no%20faces%20no%20logos&width=800&height=500&seq=carousel-04-animation&orientation=landscape',
    alt: '动画电影盛宴',
  },
  {
    title: '纪录片推荐',
    desc: '自然、人文、科技、历史纪录片精选，用真实镜头探索世界奥秘，开阔视野的最佳选择。',
    img: 'https://readdy.ai/api/search-image?query=Serene%20natural%20landscape%20with%20warm%20golden%20hour%20sunlight%20streaming%20through%20trees%2C%20documentary%20film%20aesthetic%2C%20rich%20earthy%20tones%20with%20soft%20focus%2C%20peaceful%20and%20contemplative%20atmosphere%2C%20no%20text%20no%20faces%20no%20logos%2C%20cinematic%20wide%20shot&width=800&height=500&seq=carousel-05-doc&orientation=landscape',
    alt: '纪录片推荐',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading text-foreground-900 mb-3">
            焦点专题
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
            精心策划五大主题专区，助您快速找到心仪好片
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-5">
          {topics.map((item, i) => (
            <div
              key={i}
              className="group rounded-xl overflow-hidden bg-background-100 border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="relative h-44 overflow-hidden">
                <img
                  src={item.img}
                  alt={item.alt}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  onError={(e) => {
                    (e.target as HTMLElement).style.display = 'none';
                  }}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent"></div>
              </div>
              <div className="p-4">
                <h3 className="text-base font-heading text-foreground-900 mb-1.5 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-foreground-500 text-xs leading-relaxed line-clamp-2">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}